import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Add, Delete, Edit } from "@mui/icons-material";
import useViewModel from "./ViewModel";
import { useNavigate } from "react-router-dom";
import { FormState, UserInterfaceState } from "../../../../shared/Enum";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../../store/profile/selector";
import ConfirmationDialog from "../../../../shared/Components/ConfirmationDialog";
import LoadingBackdrop from "../../../../shared/Components/LoadingBackdrop";
import PageContentHeader from "../../../../shared/Components/PageContentHeader";

export function PreventiveMEPage() {
  const { data, method } = useViewModel();
  const [location, setLocation] = useState("");
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");
  const navigate = useNavigate();
  const profile = useSelector(selectProfile);

  useEffect(() => {
    method.onGetLocationList();
  }, []);

  useEffect(() => {
    method.onGetPreventiveMEList(location);
  }, [location]);

  useEffect(() => {
    if (FormState.isSuccess(data.formState)) {
      method.onGetPreventiveMEList(location);
    }
  }, [data.formState]);
  /* eslint-disable no-restricted-globals */
  /* eslint-disable unicorn/no-useless-undefined */

  const columns: GridColDef[] = [
    {
      field: "name",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Form Name</Typography>
      ),
      renderCell: (e) => <Typography className="p-3">{e.row.name}</Typography>,
      width: 400,
    },
    {
      field: "type",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Form Type</Typography>
      ),
      renderCell: (e) => (
        <Typography className="p-3">
          {e.row.type == "DAILY" ? "Form Harian" : "Form 3 Bulanan"}
        </Typography>
      ),
      width: 200,
    },
    {
      field: "location",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Location</Typography>
      ),
      renderCell: (e) => {
        const locationMap: Record<string, string> = {};
        data.locationList.forEach((loc) => {
          locationMap[loc.locationId] = loc.locationName;
        });
        return (
          <Typography className="p-3">{locationMap[e.row.location]}</Typography>
        );
      },
      width: 200,
    },
    {
      field: "link",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Form Link</Typography>
      ),
      renderCell: (e) => (
        <Typography className="p-3 truncate underline text-[#0000EE]">
          <a href={e.row.link} target="_blank">
            {e.row.link}
          </a>
        </Typography>
      ),
      width: 500,
    },
    {
      field: "action",
      renderHeader: () => (
        <Typography className="font-bold p-3 text-lg">Action</Typography>
      ),
      renderCell: (e) => (
        <Box className="flex gap-2">
          <Button
            variant="contained"
            className="mt-1"
            onClick={() => navigate(`/preventive-me/${e.row.id}`)}
          >
            <Edit />
          </Button>
          <Button
            variant="outlined"
            className="mt-1"
            onClick={() => {
              setIdToDelete(e.row.id);
              setDeleteDialog(true);
            }}
          >
            <Delete />
          </Button>
        </Box>
      ),
      width: 200,
    },
  ];

  return (
    <Box className="flex flex-col w-full p-5">
      <PageContentHeader label="List of Preventive ME" />
      <ConfirmationDialog
        open={deleteDialog}
        description="Are you sure you want to delete this form?"
        onCancel={() => setDeleteDialog(false)}
        onClose={() => setDeleteDialog(false)}
        onSubmit={() => {
          method.onDeletePreventiveME({
            binusianId: profile.binusianId,
            PreventiveMEId: idToDelete,
          });
          setDeleteDialog(false);
        }}
      />
      <Box className="flex justify-between p-3 w-full">
        <FormControl>
          <Typography className="text-lg">Location Name</Typography>
          <Select
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="bg-white"
            displayEmpty
          >
            <MenuItem value="">All Location</MenuItem>
            {data.locationList.map((e) => (
              <MenuItem value={e.locationId}>{e.locationName}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          className="flex h-min"
          onClick={() => {
            navigate("/preventive-me/create");
          }}
        >
          <Add />
          Add New
        </Button>
      </Box>
      <div className="bg-white m-3 border border-gray-400">
        <DataGrid
          rows={data.preventiveMEList}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowId={(row) => row.id}
          pageSizeOptions={[5, 10]}
          autoHeight
          getRowHeight={() => "auto"}
        />
      </div>
      <LoadingBackdrop
        isOpen={
          UserInterfaceState.isLoading(data.uiState) ||
          FormState.isLoading(data.formState)
        }
      />
    </Box>
  );
}
